export default __webpack_public_path__ + "static/media/ic-candidate-management-1.798d17b5.svg";